var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"custom-icon-button",on:{"click":function($event){return _vm.$emit('btnClicked')},"mouseover":function($event){_vm.isHovered = true},"mouseleave":function($event){_vm.isHovered = false}}},[_c('div',{staticClass:"custom-icon-container",style:({
            width: _vm.width,
            height: _vm.height,
            padding: _vm.padding,
            border: _vm.border,
            borderRadius: _vm.radius,
            'background-color': _vm.hoveredFeature ? (_vm.isHovered ? _vm.hoveredBgColor : _vm.bgColor) : _vm.bgColor,
        })},[_c('DynamicSvg',{attrs:{"name":_vm.iconName,"color":_vm.iconColor}})],1)])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4006e4a0","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/common/IconButton.vue
// module id = Wi7V
// module chunks = 0